import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col, CardTitle } from "reactstrap";

import {
  getRequest,
  postRequest,
  deleteRequest,
} from "../../components/Common/Utils.js";
// import DonutChart from "../AllCharts/DonutChart";
import CountUp from "react-countup";
import { useHistory, useParams, useLocation } from "react-router-dom";
import ChartComponets from "./ChartData.js";
import TopAnalyticList from "./TopAnalyticList.js";
import Notifications from "./Notifications.js";
const MonthlyEarnings = (props) => {
  let history = useHistory();
  const [userdata, setuserdata] = useState({});
  const [loader, setLoader] = useState(false);
  const [alretsCredits, setAlretscredit] = useState([]);

  useEffect(() => {
    dsManagment();
    fetachAlretscredit();
  }, []);

  const dsManagment = async (page = 0) => {
    setLoader(true);
    const response = await postRequest(`analytics/admin/counts`);
    const data = response;
    console.log("count", data);
    setuserdata(data);
    // setSearchText('');
    setLoader(false);
  };
  const fetachAlretscredit = async (page = 0) => {
    setLoader(true);
    const response = await postRequest(`order/admin/credit-limit-alerts`);
    const data = response;
    setAlretscredit(data?.data);
    setLoader(false);
  };

  return (
    <React.Fragment>
      <Row>
        <Col xl={alretsCredits?.length > 0 ? 8 : 12}>
          <Row>
            <Col xl={3}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-4">Users</CardTitle>
                  <Row className="text-center mt-4">

                    <div className="col-12 align-items-center">
                      {/* Middle section */}
                      <Link to='/users'>
                        <h2>
                          <CountUp
                            start={0}
                            end={userdata?.data?.totalUsers || 0}
                            duration={1.5}
                          />
                        </h2>

                        <p className="text-muted">Users</p>
                      </Link>
                    </div>

                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3}>
              <Card>
                <CardBody onClick={() => history("/Component")}>
                  <CardTitle className="h4 mb-4">Shops</CardTitle>

                  <Row className="text-center mt-4">

                    <div className="col-12 align-items-center">
                      {/* Middle section */}
                      <Link to='/shops'>
                        <h2>
                          <CountUp
                            start={0}
                            end={userdata?.data?.totalShops || 0}
                            duration={1.5}
                          />
                        </h2>
                        <p className="text-muted">Shops</p>
                      </Link>
                    </div>

                  </Row>
                </CardBody>
              </Card>
            </Col>

            <Col xl={3}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-4">Suppliers</CardTitle>

                  <Row className="text-center mt-4">

                    <div className="col-12 align-items-center">
                      {/* Middle section */}
                      <Link to='/manufacturers'>
                        <h2>
                          <CountUp
                            start={0}
                            end={userdata?.data?.totalManufacturers || 0}
                            duration={1.5}
                          />
                        </h2>
                        <p className="text-muted">Suppliers</p>
                      </Link>
                    </div>


                  </Row>

                </CardBody>

              </Card>
            </Col>

            <Col xl={3}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-4">Orders</CardTitle>

                  <Row className="text-center mt-4">

                    <div className="col-12 align-items-center">
                      {/* Middle section */}
                      <Link to='/order-list'>
                        <h2>
                          <CountUp
                            start={0}
                            end={userdata?.data?.totalorders || 0}
                            duration={1.5}
                          />
                        </h2>
                        <p className="text-muted">Orders</p>
                      </Link>
                    </div>

                  </Row>

                </CardBody>

              </Card>
            </Col>

            <Col xl={3}>

              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-4">Delivery Agents</CardTitle>

                  <Row className="text-center mt-4">

                    <div className="col-12 align-items-center">
                      {/* Middle section */}
                      <Link to='/delivery-agents'>
                        <h2>
                          <CountUp
                            start={0}
                            end={userdata?.data?.totalDeliveryAgents || 0}
                            duration={1.5}
                          />
                        </h2>
                        <p className="text-muted">Agents</p>
                      </Link>
                    </div>


                  </Row>

                </CardBody>

              </Card>
            </Col>

            <Col xl={3}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-4">Total Products</CardTitle>

                  <Row className="text-center mt-4">

                    <div className="col-12 align-items-center">
                      {/* Middle section */}
                      <Link to='/productlist'>
                        <h2>
                          <CountUp
                            start={0}
                            end={userdata?.data?.totalProducts || 0}
                            duration={1.5}
                          />
                        </h2>
                        <p className="text-muted">Products</p>
                      </Link>
                    </div>


                  </Row>

                </CardBody>

              </Card>
            </Col>

            <Col xl={3}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-4">Warehouse</CardTitle>

                  <Row className="text-center mt-4">

                    <div className="col-12 align-items-center">
                      {/* Middle section */}
                      <Link to='/warehouse-list'>
                        <h2>
                          <CountUp
                            start={0}
                            end={userdata?.data?.totalWarehouses || 0}
                            duration={1.5}
                          />
                        </h2>
                        <p className="text-muted">Warehouse</p>
                      </Link>
                    </div>

                  </Row>

                </CardBody>

              </Card>


            </Col>

            <Col xl={3}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-4">Pending Orders</CardTitle>

                  <Row className="text-center mt-4">

                    <div className="col-12 align-items-center">
                      {/* Middle section */}
                      <Link to='/order-list'>
                        <h2>
                          <CountUp
                            start={0}
                            end={userdata?.data?.totalPendingOrders || 0}
                            duration={1.5}
                          />
                        </h2>
                        <p className="text-muted"> Orders</p>
                      </Link>
                    </div>

                  </Row>

                </CardBody>

              </Card>

            </Col>



            {/* <Col xl={3}>


            <Card>
                <CardBody>
                    <CardTitle className="h4 mb-4">Bookings</CardTitle>

                    <Row className="text-center mt-4">

                    <div className="col-4">
      
    </div>
    <div className="col-4 align-items-center">
      
      <span>
                        <h2>
                            <CountUp
                                start={0}
                                end={userdata?.data?.allBookingCount || 0}
                                duration={1.5}
                            />
                            </h2>
                            <a href="/bookings">                           
                               <p className="text-muted">Bookings</p>
                            </a>
                           
      </span>
    </div>
    <div className="col-4 align-items-center">
      
      <Link to={{ 
                                  pathname: '/chart', 
                                  state: { component: 'booking' } 
                                }}
                              >
                                <i className="fas fa-chart-bar" style={{ fontSize: "3rem" }}></i>
                              </Link>
                        </div>
                        
                    </Row>      

                </CardBody>
                
            </Card>


            </Col>
            <Col xl={3}>

            <Card>
              <CardBody>
                <CardTitle className="h4 mb-4">Banners</CardTitle>

                <Row className="text-center mt-4">
                  <div className="col-4">
                   
                  </div>
                  <div className="col-4 align-items-center">
                    
                    <span>
                      <h2>
                        <CountUp
                          start={0}
                          end={userdata?.data?.bannerCount || 0}
                          duration={1.5}
                        />
                      </h2>
                      <a href="/banner">
                        <p className="text-muted">Banners</p>
                      </a>
                    </span>
                  </div>
                  <div className="col-4 align-items-center">
                   
                    <Link to={{
                      pathname: '/chart',
                      state: { component: 'banners' }
                    }}>
                      <i className="fas fa-chart-bar" style={{ fontSize: "3rem" }}></i>
                    </Link>
                  </div>
                </Row>           
              </CardBody>
            </Card>



            </Col>
               <Col xl={3}>
               <Card>
                  <CardBody>
                    <CardTitle className="h4 mb-4">Category</CardTitle>

                    <Row className="text-center mt-4">
                      <div className="col-4">
                        
                      </div>
                      <div className="col-4 align-items-center">
                        
                        <span>
                          <h2>
                            <CountUp
                              start={0}
                              end={userdata?.data?.categoryCount || 0}
                              duration={1.5}
                            />
                          </h2>
                          <a href="/Category">
                            <p className="text-muted">Category</p>
                          </a>
                        </span>
                      </div>
                      <div className="col-4 align-items-center">
                        
                        <Link to={{
                          pathname: '/chart',
                          state: { component: 'category' }
                        }}>
                          <i className="fas fa-chart-bar" style={{ fontSize: "3rem" }}></i>
                        </Link>
                      </div>
                    </Row>           
                  </CardBody>
                </Card>



            </Col>
            <Col xl={3}>
            <Card>
                <CardBody>
                  <CardTitle className="h4 mb-4">HomeBlock</CardTitle>

                  <Row className="text-center mt-4">
                    <div className="col-4">
                     
                    </div>
                    <div className="col-4 align-items-center">
                      
                      <span>
                        <h2>
                          <CountUp
                            start={0}
                            end={userdata?.data?.homeBlockCount || 0}
                            duration={1.5}
                          />
                        </h2>
                        <a href="/homeblock">
                          <p className="text-muted">HomeBlock</p>
                        </a>
                      </span>
                    </div>
                    <div className="col-4 align-items-center">
                      
                      <Link to={{
                        pathname: '/chart',
                        state: { component: 'home-blocks' }
                      }}>
                        <i className="fas fa-chart-bar" style={{ fontSize: "3rem" }}></i>
                      </Link>
                    </div>
                  </Row>           
                </CardBody>
              </Card>

            </Col> */}

          </Row>
        </Col>
        {alretsCredits?.length > 0 &&
        <Col xl={4}>
          <div className="top-analtics row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-title reminder">
                  <h4>Supplier Pay Reminder</h4>
                </div>
                <div
                  className="mt-3 card-body" style={{ height: '287px', overflowX: 'hidden' }}>
                  <div className="Toastify" />
                  <div className="row">
                    <div className="col-12 col">
                      <div className="">
                        <div className="row">
                          {alretsCredits?.map((item, index) => {
                            // Determine background color based on remainingCreditDays
                            let alertBgColor = "";
                            if (item.remainingCreditDays <= 0) {
                              alertBgColor = "bg-dangers"; // Red for 0 days
                            } else if (item.remainingCreditDays < 4) {
                              alertBgColor = "bg-softwarnings"; // Orange for 3 days
                            } else if (item.remainingCreditDays < 2) {
                              alertBgColor = "bg-warnings"; // Orange for 1 day
                            }
                            return (
                              <div className={`col-lg-12 alert-1 ${alertBgColor}`} key={index}>
                                <div className="d-flex gap-2 align-items-center" style={{ justifyContent: 'space-between' }}>
                                  <div className="d-flex gap-2 align-items-center">
                                    <Link to={`/order-sent-manufacturer/${item?._id}`}>
                                      <div className="d-flex align-items-center" style={{ width: 40, height: '40px' }}>
                                        <img
                                          src={item?.manufacturer?.logo}
                                          width="40px"
                                        />
                                      </div>
                                    </Link>
                                    <div className="flex-product text-start">
                                     <Link to={`/order-sent-manufacturer/${item?._id}`} style={{color : '#000'}}>
                                        {item?.manufacturer?.companyName}
                                      </Link>
                                      <p className="mb-0"> Amount : ${item?.totalAmount}</p>
                                    </div>
                                  </div>
                                  <div className="d-flex gap-2 align-items-center">
                                    <p className="mb-0">Due in : {item?.remainingCreditDays === 0 ? <>Today</> : <>{item?.remainingCreditDays} Day</>}</p>
                                    <button type="button" class=" btn btn-primary text-light">
                                      <Link to={`/order-sent-manufacturer/${item?._id}`}><i class="fal fa-eye text-light"></i></Link></button>
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col> }
      </Row>

      <Notifications/>

      <TopAnalyticList />


      <Row>

        {/* <Col xl={3}>
            <Card>
              <CardBody>
                <CardTitle className="h4 mb-4">Notifications</CardTitle>

                <Row className="text-center mt-4">
                  <div className="col-4">
                   
                  </div>
                  <div className="col-4 align-items-center">
                    
                    <span>
                      <h2>
                        <CountUp
                          start={0}
                          end={userdata?.data?.notificationCount || 0}
                          duration={1.5}
                        />
                      </h2>
                      <a href="/notification">
                        <p className="text-muted">Notification</p>
                      </a>
                    </span>
                  </div>
                  <div className="col-4 align-items-center">
                    
                    <Link to={{
                      pathname: '/chart',
                      state: { component: 'notifications' }
                    }}>
                      <i className="fas fa-chart-bar" style={{ fontSize: "3rem" }}></i>
                    </Link>
                  </div>
                </Row>           
              </CardBody>
            </Card>
            </Col> */}
        {/* <Col xl={3}>
         <Card>
          <CardBody>
            <CardTitle className="h4 mb-4">Hotel Reviews</CardTitle>

            <Row className="text-center mt-4">
              <div className="col-4">
              
              </div>
              <div className="col-4 align-items-center">
                
                <span>
                  <h2>
                    <CountUp
                      start={0}
                      end={userdata?.data?.hotelReviewCount || 0}
                      duration={1.5}
                    />
                  </h2>
                  <a href="/hotelratings">
                    <p className="text-muted">Reviews</p>
                  </a>
                </span>
              </div>
              <div className="col-4 align-items-center">
                
                <Link to={{
                  pathname: '/chart',
                  state: { component: 'hotel-review' }
                }}>
                  <i className="fas fa-chart-bar" style={{ fontSize: "3rem" }}></i>
                </Link>
              </div>
            </Row>           
          </CardBody>
        </Card>

            </Col> */}
        {/* <Col xl={3}>
            <Card>
              <CardBody>
                <CardTitle className="h4 mb-4">Transfer Reviews</CardTitle>

                <Row className="text-center mt-4">
                  <div className="col-4">
                   
                  </div>
                  <div className="col-4 align-items-center">
                    
                    <span>
                      <h2>
                        <CountUp
                          start={0}
                          end={userdata?.data?.transferReviewCount || 0}
                          duration={1.5}
                        />
                      </h2>
                      <a href="/transferratings">
                        <p className="text-muted">Reviews</p>
                      </a>
                    </span>
                  </div>
                  <div className="col-4 align-items-center">
                   
                    <Link to={{
                      pathname: '/chart',
                      state: { component: 'transfer-review' }
                    }}>
                      <i className="fas fa-chart-bar" style={{ fontSize: "3rem" }}></i>
                    </Link>
                  </div>
                </Row>           
              </CardBody>
            </Card>

            </Col>  */}
        {/* <Col xl={3}>
            <Card>
              <CardBody>
                <CardTitle className="h4 mb-4">Ticket Reviews</CardTitle>

                <Row className="text-center mt-4">
                  <div className="col-4">
                    
                  </div>
                  <div className="col-4 align-items-center">
                    
                    <span>
                      <h2>
                        <CountUp
                          start={0}
                          end={userdata?.data?.ticketReviewCount || 0}
                          duration={1.5}
                        />
                      </h2>
                      <a href="/ticketratings">
                        <p className="text-muted">Reviews</p>
                      </a>
                    </span>
                  </div>
                  <div className="col-4 align-items-center">
                   
                    <Link to={{
                      pathname: '/chart',
                      state: { component: 'ticket-review' }
                    }}>
                      <i className="fas fa-chart-bar" style={{ fontSize: "3rem" }}></i>
                    </Link>
                  </div>
                </Row>           
              </CardBody>
            </Card>

            </Col>  */}

      </Row>

      {/* <ChartComponets /> */}

    </React.Fragment>
  );
};

export default MonthlyEarnings;
